import React from 'react';
import './AccountVolunteeringTableEmpty.css';

export default function AccountVolunteeringTableEmpty() {
  return (
    <div className="empty-info"> 
      <button className="empty-info__btn btn btn-blue">להוספת דיווח ראשון</button> 
    </div>
  )
}
